<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box">
            <div class="jgMsg" :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1200px',
         overflow:'hidden'
         
        }">
                <div
                    :style="{position:position,zIndex:100,background:'#fff',top:toptop,marginBottom:'30px',width:wid,borderBottom:'1px solid #e5e5e5'}">
                    <div style="display: flex;">
                        <div class="addBtn inv" @click="addBtn">
                            <i class="el-icon-plus"></i>添加合作方
                        </div>
                        <div style="flex:1;display:flex" class="AZ">
                            <li v-show="listShow" :class="{liActive : active =='all'}" @click="mouseover1"
                                style="font-size: 14px;">全部</li>
                            <li v-show="listShow" :class="{liActive : active == item}" @click="mouseover(item)"
                                v-for="(item,index) in A_Z" :key="index" style="font-size: 14px;">{{item}}</li>


                        </div>


                        <div v-show="openShow" class="addBtn inv" @click="open">
                            查看更多 <i class="el-icon-arrow-down"></i>
                        </div>
                        <div v-show="!openShow" class="addBtn inv" @click="up">
                            点击收起 <i class="el-icon-arrow-up"></i>
                        </div>
                    </div>
                    <div class="LogoBox"
                        :style="{overflowY:overFlow,maxHeight:LogoHeight,minHeight:'60px',marginBottom:'30px',}">
                        <a @click="jump(item.id)" v-for="(item,index) in listArr">

                            <img style="width: 100px;height: 53px;margin-top: 4px;" v-if='item.selfImage&& item.type==0'
                                :src="api + item.selfImage" alt="">
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <img style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;"
                                    v-if='item.selfImage&& item.type==1' :src="api + item.selfImage" alt="">
                                <span>{{item.simpleName}}</span>
                            </div>
                            <span v-if='!item.selfImage'>{{item.simpleName}}</span>
                            <p>{{item.simpleName}}</p>
                        </a>
                       
                     
                     
                    </div>
                </div>
                <!-- <div style="margin-bottom: 30px;border-top:1px solid #e5e5e5;"></div> -->
                <!-- 投顾列表 -->
             
                <div :style="{boxSizing: 'border-box',marginTop:mt}">
                        <div :class="{aColor:idColor ==item.id}" v-if="details" :id="'a'+item.id"
                            class="listMsg listMsg_" @click="pushDetail(item.id)" v-for="(item,index) in list"
                            :key=index>
                            <img v-if="item.selfImage" :src="api + item.selfImage">
                            <img v-if="!item.selfImage && item.type==1" src="../../../assets/images/crm/tx.jpg">
                            <img v-if="!item.selfImage && item.type==0" src="../../../assets/images/crm/nav/jg.png">
                            <div class="msgFlex">
                                <!-- 投顾名称 -->
                                <div class="jgName">
                                    <h2>{{item.simpleName}}</h2>
                                    <p :style="{border:item.partner!='0'?'1px solid #b541f1':'1px solid #1cbdf2',
                                    color:item.partner!='0'?'#b541f1':'#1cbdf2',
                                    background:item.partner!='0'?'#fbf5ff':'#f7fdff',marginRight:'10px'}">{{item.partner==0?'甲方':'乙方'}}</p>
                                    <p :style="{border:item.type!='0'?'1px solid #FFAB85':'',
            color:item.type!='0'?'#FFAB85':'',
            background:item.type!='0'?'#FFFDF8':'',}">{{item.type==0?'企业':'个人'}}</p>
                                   
            <p v-if=item.interim :style="{width: '50px',border: '1px solid #ff4a4a',color: '#ff4a4a',backgroundColor:'#fffafa',textAlign: 'center',lineHeight: '23px',marginLeft: '10px',position: 'relative'}">考察期
               
                </p>
                                    <!-- <div class="edit"
                            @click.stop.prevent="editBtn(item.name,item.id,item.type,item.simpleName,item.phone,item.contactor,item.address,item.selfImage,item.investorInfoFile)">
                            <span style="font-size: 13px;" class="iconfont icon-bianji"></span>&nbsp;<span class="decoration1">编辑</span></div> -->
                                    <div class="del" @click.stop.prevent="delBtn(item.simpleName,item.id)"> <span
                                            class="iconfont icon-shanchu"></span> <span class="decoration1">删除</span>
                                    </div>
                                </div>
                                <!-- 投顾信息 -->
                                <div class="jg_Msg">
                                    <li>
                                        <p>账户：<span style="font-size: 30px;color: #5B85FF;">{{item.accCount }} <span
                                                    style="font-size: 14px;">个</span></span></p>
                                    </li>
                                    <li>
                                        <p>累计收益：<span
                                                :style="{fontSize: '30px',color:item.sumProfit>=0?'#FA4B22':'#44c786'}">{{item.sumProfit|num }}
                                                <span style="font-size: 14px;">%</span></span></p>
                                    </li>
                                    <li>
                                        <p>今年收益：<span
                                                :style="{fontSize: '30px',color:item.thisYearProfit>=0?'#FA4B22':'#44c786'}"">{{item.thisYearProfit|num }}
                                    <span style=" font-size: 14px;">%</span></span></p>
                                    </li>
                                    <li>
                                        <p>本月收益：<span
                                                :style="{fontSize: '30px',color:item.thisMonthProfit>=0?'#FA4B22':'#44c786'}">{{item.thisMonthProfit|num }}
                                                <span style="
                                    font-size: 14px;">%</span></span></p>
                                    </li>
                                    <li style="flex: 1.2;">
                                        <p>累计分红：<span
                                                style="font-size: 30px;color: #FA4B22;">{{item.shareMoney|format }}
                                                <span v-if="item.shareMoney" style="font-size: 14px;">万</span> </span>
                                        </p>
                                    </li>
                                </div>
                            </div>

         
                        </div>
                    </div>
               






            </div>
        </div>

        <transition name="el-fade-in-linear">
            <!--  添加遮罩层 -->
            <div class="popContainer" v-show="addShow">
                <div class="add" :style="{ width: '680px',paddingBottom:'15PX' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        添加合作方
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
        " @click="add_close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">
                            <!-- 投顾类型 -->
                            <div class="col">
                                <div class="left"><span>*&nbsp;</span>选择合作方类型</div>
                                <div class="right" style="padding-top: 5px;">
                                    <el-radio v-model="type" label="1">企业</el-radio>
                                    <el-radio v-model="type" label="0">个人</el-radio>
                                </div>
                            </div>

                            <!--  logo -->
                            <div v-show="type=='1'" class="col" style="margin-bottom: 15px;">
                                <div class="left"><span></span>上传Logo</div>
                                <div class="right">
                                    <el-upload class="avatar-uploader"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'"
                                        :show-file-list="false" name="file" accept="image/png, image/jpeg"
                                        :on-success="handleAvatarSuccess_logo">
                                        <img v-if="logoImageUrl" style="width: 150px;height: 80px;" :src="logoImageUrl"
                                            class="avatar" />
                                        <i v-else
                                            style="color: #dcdfe6;width: 150px;height: 80px;line-height: 80px; border: 1px dashed #dcdfe6;"
                                            class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>



                            <!-- 企业 -->
                            <!--  营业执照上传 -->
                            <!-- <div>
                                <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                    <div class="left"><span>*&nbsp;</span>营业执照上传</div>
                                    <div class="right">
                                        <el-upload class="avatar-uploader"
                                            :action="this.$store.state.api + '/ad/upload/upload_file'"
                                            :show-file-list="false" name="file" accept="image/png, image/jpeg"
                                            :on-success="handleAvatarSuccess">
                                            <img v-if="imageUrl" style="width: 75px;height: 75px;" :src="imageUrl"
                                                class="avatar" />
                                            <i v-else
                                                style="color: #dcdfe6;width: 75px;height: 75px;line-height: 75px; border: 1px dashed #dcdfe6;"
                                                class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </div>
                                </div>


                            </div> -->



                            <!--  企业名称 -->
                            <!-- <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>企业名称</div>
                                <div class="right">
                                    <el-input v-model="qy_name" placeholder="请输入企业名称"></el-input>
                                </div>
                            </div> -->

                            <!-- 简称 -->
                            <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>企业简称</div>
                                <div class="right">
                                    <el-input v-model="jc_name" placeholder="请输入企业名称"></el-input>
                                </div>
                            </div>

                            <!--  社会信用代码 -->
                            <!-- <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>社会信用代码</div>
                                <div class="right">
                                    <el-input v-model="qy_register" placeholder="请输入社会信用代码"></el-input>
                                </div>
                            </div> -->

                            <!-- 成立时间 -->
                            <!-- <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>成立时间</div>
                                <div class="right">
                                    <el-input v-model="time" placeholder="请输入公司成立时间"></el-input>
                                </div>
                            </div> -->

                            <!-- <div v-show="type=='1'" class="col" style="margin-bottom: 15px;">
                                <div class="left"><span>*&nbsp;</span>成立时间</span></div>
                                <div class="right">
                                    <el-date-picker v-model="time" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择公司成立时间">

                                    </el-date-picker>
                                </div>
                            </div> -->


                            <!-- 联系人 -->
                            <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span></span>联系人</span></div>
                                <div class="right">
                                    <el-input v-model="name" placeholder="请填写联系人"></el-input>
                                </div>
                            </div>

                            <!-- 联系电话 -->
                            <div v-show="type=='1'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span></span>电话</span></div>
                                <div class="right">
                                    <el-input v-model="phone" placeholder="请输入联系方式"></el-input>
                                </div>
                            </div>


                            <div v-show="type=='0'" class="col" style="margin-bottom: 15px;">
                                <div class="left"><span></span>上传照片</div>
                                <div class="right">
                                    <el-upload class="avatar-uploader"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'"
                                        :show-file-list="false" name="file" accept="image/png, image/jpeg"
                                        :on-success="handleAvatarSuccess_logo">
                                        <img v-if="logoImageUrl" style="width: 80px;height: 80px;" :src="logoImageUrl"
                                            class="avatar" />
                                        <i v-else
                                            style="color: #dcdfe6;width: 80px;height: 80px;line-height: 80px; border: 1px dashed #dcdfe6;"
                                            class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>

                            <!-- 个人 -->
                            <!--  身份证上传 -->
                            <div style="position: relative;">
                                <!-- <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                    <div class="left"><span>*&nbsp;</span>身份证上传</div>
                                    <div class="right">
                                        <el-upload class="avatar-uploader"
                                            :action="this.$store.state.api + '/ad/upload/upload_file'"
                                            :show-file-list="false" name="file" accept="image/png, image/jpeg"
                                            :on-success="handleAvatarSuccess_t">
                                            <img v-if="imageUrl_t" style="width: 75px;height: 75px;" :src="imageUrl_t"
                                                class="avatar" />
                                            <i v-else
                                                style="color: #dcdfe6;width: 75px;height: 75px;line-height: 75px; border: 1px dashed #dcdfe6;"
                                                class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </div>
                                </div> -->

                                <!--  logo -->

                            </div>




                            <!-- 姓名 -->
                            <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>姓名</span></div>
                                <div class="right">
                                    <el-input v-model="username" placeholder="请输入姓名"></el-input>
                                </div>
                            </div>

                            <!-- 身份证号 -->
                            <!-- <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>身份证号</span></div>
                                <div class="right">
                                    <el-input v-model="userId" placeholder="请输入身份证号"></el-input>
                                </div>
                            </div> -->


                            <!-- 出生日期 -->
                            <!-- <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>出生日期</span></div>
                                <div class="right">
                                    <el-input v-model="birthTime" placeholder="请输入出生日期"></el-input>
                                </div>
                            </div> -->

                            <!-- <div v-show="type=='0'" class="col" style="margin-bottom: 15px;">
                                <div class="left"><span>*&nbsp;</span>出生日期</span></div>
                                <div class="right">
                                    <el-date-picker v-model="birthTime" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择出生日期">

                                    </el-date-picker>
                                </div>
                            </div> -->



                            <!-- 联系人 -->
                            <!-- <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span></span>联系人</span></div>
                                <div class="right">
                                    <el-input v-model="contactor" placeholder="请输入联系人名称"></el-input>
                                </div>
                            </div> -->

                            <!-- 联系方式 -->
                            <div v-show="type=='0'" class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span></span>电话</span></div>
                                <div class="right">
                                    <el-input v-model="userPhone" placeholder="请输入联系方式"></el-input>
                                </div>
                            </div>



                            <!-- 邮箱 -->
                            <div  class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span></span>邮箱</span></div>
                                <div class="right">
                                    <el-input v-model="email" placeholder="请输入邮箱（可支持提醒功能）"></el-input>
                                </div>
                            </div>

                            <!-- 合作方向 -->
                            <div  class="col" style="margin-bottom: 15PX;">
                                <div class="left" style="margin-top: 0;"><span></span>合作方向</span></div>
                                <div class="right">
                                    <el-radio v-model="partner" label="0">甲方</el-radio>
                                    <el-radio v-model="partner" label="1">乙方</el-radio>
                                </div>
                            </div>

                            <!-- 是否试用 -->
                            <div  class="col" style="margin-bottom: 15PX;">
                                <div class="left" style="margin-top: 0;"><span></span>是否试用</span></div>
                                <div class="right">
                                    <el-radio v-model="interim" label="true">是</el-radio>
                                    <el-radio v-model="interim" label="false">否</el-radio>
                                </div>
                            </div>

                            <!--  投资范围-->
                            <!-- <div class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>投资范围</span></div>
                                <div class="right">
                                    <el-input v-model="Range" placeholder="请填写投资范围"></el-input>
                                </div>
                            </div> -->

                            <!-- 尽调表上传 -->
                            <!--  附件上传 -->
                            <!-- <div class="col" style="margin-bottom: 15PX;">
                                <div class="left"><span>*&nbsp;</span>附件上传</div>
                                <div class="right">
                                    <p style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;">
                                        请上传尽调表。 </p>

                                    <el-upload class="avatar-uploader"
                                    ref="my-upload"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'"
                                        :on-remove="delBtn__t" name="file" accept=".docx,.doc" :limit=1
                                        :on-success="handleAvatarSuccess__t">
                                        <i
                                            style="color: #fff;width: 76px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display: block;font-size: 12px;line-height: 24px;">上传文件</i>
                                    </el-upload>
                                </div>
                            </div> -->



                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="add_close">取消</button> -->
                        <button @click='submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="el-fade-in-linear">
            <!--  添加遮罩层 -->
            <div class="popContainer" v-show="editShow">
                <div class="add" :style="{ width: '680px',paddingBottom:'15PX' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        编辑
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
          " @click="add_close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">


                            <!--  logo -->
                            <div class="col">
                                <div class="left">{{state==0?'上传Logo':'上传照片'}}</div>
                                <div class="right">
                                    <el-upload class="avatar-uploader"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'"
                                        :show-file-list="false" name="file" accept="image/png, image/jpeg"
                                        :on-success="handleAvatarSuccess_logo">
                                        <img v-if="logoImageUrl" style="width: 150px;height: 80px;object-fit: contain;"
                                            :src="logoImageUrl" class="avatar" />
                                        <i v-else
                                            style="color: #dcdfe6;width: 150px;height: 80px;line-height: 80px; border: 1px dashed #dcdfe6;"
                                            class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div>


                            <!-- 简称 -->
                            <div v-if='state==0' class="col" style="margin-bottom: 15PX;">
                                <div class="left">企业简称</div>
                                <div class="right">
                                    <el-input v-model="jc_name" placeholder="请输入企业简称"></el-input>
                                </div>
                            </div>



                            <!-- 联系人 -->
                            <div class="col" style="margin-bottom: 15PX;">
                                <div class="left">联系人</span></div>
                                <div class="right">
                                    <el-input v-model="contactor" placeholder="请输入联系人名称"></el-input>
                                </div>
                            </div>

                            <!-- 联系方式 -->
                            <div class="col" style="margin-bottom: 15PX;">
                                <div class="left">联系方式</span></div>
                                <div class="right">
                                    <el-input v-model="userPhone" placeholder="请输入联系方式"></el-input>
                                </div>
                            </div>

                            <!--  投资范围-->
                            <!-- <div class="col" style="margin-bottom: 15PX;">
                                <div class="left">投资范围</span></div>
                                <div class="right">
                                    <el-input v-model="Range" placeholder="请填写投资范围"></el-input>
                                </div>
                            </div> -->

                            <!-- 尽调表上传 -->
                            <!--  附件上传 -->
                            <!-- <div class="col" style="margin-bottom: 15PX;">
                                <div class="left">附件上传</div>
                                <div class="right">
                                    <p style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;">
                                        请上传尽调表。
                                    </p>

                                    <el-upload class="avatar-uploader"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'"
                                        :on-remove="delBtn__t" name="file" accept=".docx,.doc" :limit=1
                                        :on-success="handleAvatarSuccess__t">
                                        <i
                                            style="color: #fff;width: 80px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display: block;font-size: 14px;line-height: 24px;">上传文件</i>
                                    </el-upload>
                                </div>
                            </div> -->



                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="edit_close">取消</button> -->
                        <button @click='edit_submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import hhead from '../header/index';
    import crmNav from '../../../components/crmNav/index';
    import './style.css';
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                AZ: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                A_Z: [],
                listShow: false,
                partner:'1',//合作方向  甲方'0' 乙方'1'
                overFlow: 'hidden',
                openShow: true,
                interim:'false',//是否试用
                LogoHeight: '60px',
                details: true,
                active: 'all',//字母class名
                api: this.$store.state.api,
                res: '',//投顾信息
                contractList: [],//合作信息
                userList: [],//账户列表
                dividendList: [],//分红记录
                activeName: '1',
                MWidth: '',
             
                option: [],
                tableList: [],
                tabL: '',
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                addShow: false,
                type: '1', //投顾类型
                imageUrl: '',
                logoImageUrl: '',//logo
                // imgPath: '',//
                // imgPath_t: '',//
                logoImgPath: '',
                jc_name: '',//企业简称
                // qy_name: '',// 企业名称
                // time: '',//成立时间
                name: '',//联系人
                email:'',//邮箱
                // qy_register: '',// 社会信用代码
                phone: '',//联系电话
                Range: '',//投资金额
                imageUrl_t: '',//尽调表
                username: '',//个人姓名
                // userId: '',//身份证号
                // birthTime: '',//出生日期
                // address:'',//籍贯地址
                userPhone: '',//个人联系方式
                list: [],//列表信息
                listArr: [],
                contactor: '',//联系人
                editShow: false,//编辑显示隐藏
                invId: '',//投顾id
                state: '',//编辑投顾 0企业 1个人
                idColor: '',
                position: 'relative',
                wid: '',
                mt: '0',
                toptop:'0px'
            };
        },
        filters: {
            datas: function (date) {
                return date.substr(0, 10).replace('/', '年').replace('/', '月') + '日'
            },
            num: function (n) {
                if (n) {
                    return (Math.round(n * 10000) / 100).toFixed(2)
                } else {
                    return '0.00'
                }
            },
            date: function (date) {
                if (date) {
                    return date.substr(0, 10).replace('/', '-').replace('/', '-')
                }
            },
            num1: function (n) { //数字格式化
                if (n) {

                    return Math.round(n * 10000) / 100
                } else {
                    return 0
                }
            },
            num3: function (n) {
                if (n) {
                    return n.toFixed(4)
                }
            },
            format: function (n) {
                if (n) {

                    return Math.round(n / 10000)
                } else {
                    return '0'
                }
            }
        },
        mounted() {
            this.axiosList()

            window.addEventListener('scroll', this.handleScroll)
            let w = document.body.clientWidth;
            // console.log(w - 310)
            this.wid = w - (260 + 60 + 87) + 'px'
        },

        methods: {
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // console.log(scrollTop)
                if (scrollTop >= 30) {
                    this.position = 'fixed'
                    this.toptop = '54px'
                    if (this.LogoHeight == '177px') {
                        this.mt = '377px'
                    } else {
                        this.mt = '200px'
                    }
                } else {
                    this.mt = '0'
                    this.toptop = '0px'
                    this.position = 'relative'
                }

            },
            jump(id) {
                let scr = document.getElementById('a' + id)

                // console.log(scr)
                // console.log(scr.offsetTop)
                if(this.LogoHeight=='60px'){

                document.documentElement.scrollTop = scr.offsetTop - 160
                }else if(this.LogoHeight!='60px'&&this.listArr.length>11&&this.listArr.length<=22){
                    document.documentElement.scrollTop = scr.offsetTop - 220
                }else{
                    document.documentElement.scrollTop = scr.offsetTop - 280
                }
                this.idColor = id
                

            },

            pushDetail(id) {
                //查看详情
                this.$router.push('/crm/InvestorManage/details?id=' + id)

            },
            open() {
                this.overFlow = 'scroll'
                this.LogoHeight = '177px'
                this.openShow = false
                this.listShow = true
            },
            up() {
                this.openShow = true
                this.LogoHeight = '60px'
                this.overFlow = 'hidden'
                this.listShow = false
                this.listArr = this.list
            },
            axiosList() { //请求列表
                this.$axios
                    .post('/crm/inverstor/queryAllInverstor', {
                        apiToken: this.$store.state.usermsg.apiToken,
                    })
                    .then((res) => {
                        // console.log(res);
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            let arr = []
                            let pinyin = require('js-pinyin');
                            pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
                            res.data.data.forEach(item => {
                                arr.push(pinyin.getFullChars(item.simpleName).substr(0, 1))
                            })
                            // console.log(arr)
                            let str = ''
                            arr.forEach((e) => {
                                if (str.indexOf(e) < 0) {
                                    str += e.toUpperCase() //转大写

                                }
                            })
                            this.A_Z = str.split('').sort()  //排序


                            this.list = res.data.data
                            this.listArr = this.list
                        }
                    });
            },
            delBtn__t() {
                //移除文件
                this.path__t = ''
            },
            submit() {
                //提交
                if (this.type == '1') {//企业
                    if (this.jc_name ) {
                        this.$axios.post(
                            '/crm/inverstor/addInverstor',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                type: 0,
                                contactor: this.name,
                                phone: this.phone,
                                simpleName: this.jc_name,
                                selfImage: this.logoImgPath,
                                mail:this.email,
                                interim:this.interim =='true'?true:false,
                                partner:this.partner
                            }
                        ).then(res => {
                            console.log(res)
                            this.tokenInvalid(res)
                            if (res.data.code == 200) {
                                this.clear()
                                this.axiosList()

                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }).catch(() => { });
                            }
                        })
                    } else {
                        this.$alert('信息不完整', {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true
                        }).then(() => { }
                        ).catch(() => { });
                    }

                } else {
                    //个人
                    if ( this.username ) {
                        this.$axios.post(
                            '/crm/inverstor/addInverstor',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                type: 1,
                                name: this.username,
                                simpleName: this.username,
                                phone: this.userPhone,
                                // contactor: this.contactor,
                                selfImage: this.logoImgPath,
                                interim:this.interim =='true'?true:false,
                                partner:this.partner
                            }
                        ).then(res => {
                            console.log(res)
                            this.tokenInvalid(res)
                            if (res.data.code == 200) {
                                this.clear()
                                this.axiosList()
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }).catch(() => { });
                            }
                        })
                    } else {
                        this.$alert('信息不完整', {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true
                        }).then(() => { }
                        ).catch(() => { });
                    }
                }
            },
            mouseover(e) {
                //字母移入事件
                this.active = e
                let arr = []
                let pinyin = require('js-pinyin');
                pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
                this.list.forEach(item => {
                    if (e == pinyin.getFullChars(item.simpleName).substr(0, 1)) {
                        arr.push(item)
                    }
                })
                this.listArr = arr
                if(this.listArr.length<=11){
                    this.LogoHeight = '60px'
                }

            },
            mouseover1() {
                this.active = 'all'
                this.listArr = this.list
                this.LogoHeight = '177px'
            },
            // handleAvatarSuccess__t(res, file) {
            //     //上传尽调表
            //     // console.log(res);
            //     if (res.code == 200) {
            //         this.path__t = res.data.filePath;
            //     }
            // },
            clear() {
                //清除输入框
                this.imageUrl = ''
                this.email = ''
                // this.imgPath = ''
                // this.imgPath_t = ''
                // this.qy_name = ''// 企业名称
                // this.time = ''//成立时间
                this.name = ''//联系人
                // this.qy_register = ''// 社会信用代码
                this.phone = ''//联系电话
                this.Range = ''//投资范围
                this.imageUrl_t = ''
                this.username = ''//个人姓名
                // this.userId = ''//身份证号
                // this.birthTime = ''//出生日期
                this.address = ''//籍贯地址
                this.userPhone = ''//个人联系方式
                this.contactor = ''
                this.addShow = false
                this.editShow = false
                this.jc_name = ''

                this.logoImgPath = ''
                this.imageUrl_t = ''
                this.logoImageUrl = ''
                this.delBtn__t()

            },
            add_close() {
                //关闭
                // 
                this.addShow = false;
                this.clear()
            },
            addBtn() {
                //添加
                this.addShow = true;
            },
            edit_submit() {
                this.$axios.post(
                    '/crm/inverstor/editInv',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        phone: this.userPhone,
                        contactor: this.contactor,
                        logo: this.logoImgPath,
                        simpleName: this.jc_name,
                        address: this.Range,
                        // investorInfoFile: this.path__t,
                        invId: this.invId
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.clear()
                        this.axiosList()
                        this.$alert('修改成功', {
                            confirmButtonText: '确定',
                            type: 'success',
                            center: true
                        }).then(() => { }).catch(() => { });
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true
                        }).then(() => { }).catch(() => { });
                    }
                })
            },
            edit_close() {

                this.clear()
            },
            editBtn(name, id, state, simpleName, phone, contactor, address, selfImage, investorInfoFile) {
                this.invId = id
                this.editShow = true
                this.state = state
                this.jc_name = simpleName
                this.userPhone = phone
                this.contactor = contactor
                this.Range = address
                this.logoImageUrl = this.$store.state.api + selfImage
                // this.path__t =this.$store.state.api + investorInfoFile
            },
            delBtn(name, id) {
                //删除投顾
                this.$confirm(`您确定要删除合作方“${name}”吗？`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$axios.post(
                        '/crm/inverstor/del',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            invId: id
                        }
                    ).then(res => {
                        // console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.axiosList()

                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }
                            ).catch(() => { });
                        }
                    })
                }
                ).catch(() => { });
            },
            // handleAvatarSuccess(res, file) {
            //     //上传营业执照
            //     // console.log(res);
            //     if (res.code == 200) {
            //         // this.$message.success(res.message);
            //         this.imageUrl = URL.createObjectURL(file.raw);
            //         this.imgPath = res.data.filePath;
            //         this.$axios
            //             .post('/crm/upload_Ent', {
            //                 path: res.data.filePath,
            //                 apiToken: this.$store.state.usermsg.apiToken,
            //             })
            //             .then((result) => {
            //                 // console.log(result);
            //                 let rep = result.data;
            //                 this.tokenInvalid(result);
            //                 if (rep.code == 200) {
            //                     this.qy_name = rep.data.company
            //                     this.qy_register = rep.data.creditNo
            //                     this.time = rep.data.createTime
            //                     this.name = rep.data.name
            //                     // this.Range = rep.data.scope || ''
            //                 }
            //             });
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            handleAvatarSuccess_logo(res, file) {
                //上传logo
                // console.log(res);
                if (res.code == 200) {
                    this.logoImageUrl = URL.createObjectURL(file.raw);
                    this.logoImgPath = res.data.filePath;
                } else {
                    this.$message.error(res.message);
                }
            },
            // handleAvatarSuccess_t(res, file) {
            //     //上传身份证
            //     // console.log(res);
            //     if (res.code == 200) {

            //         this.imageUrl_t = URL.createObjectURL(file.raw);
            //         this.imgPath_t = res.data.filePath;
            //         this.$axios
            //             .post('/crm/upload_IDCard', {
            //                 path: res.data.filePath,
            //                 apiToken: this.$store.state.usermsg.apiToken,
            //             })
            //             .then((result) => {
            //                 // console.log(result);
            //                 let rep = result.data;
            //                 this.tokenInvalid(result);
            //                 if (rep.code == 200) {
            //                     this.username = rep.data.name
            //                     this.userId = rep.data.idcardNo
            //                     this.birthTime = rep.data.birthday
            //                     this.address = rep.data.address
            //                 }
            //             });
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            Investor() {
                //点击分析

                let arrId = this.$route.query.id
                if (this.userList.length > 0) {
                    this.$router.push(`/crm/analysis/Fitting?InvestorId=${arrId}`)
                } else {
                    this.$alert('暂无账户进行分析', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                }
            },

            prev() {
                this.details = true
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/view/crm/InvestorManage/index.vue